import { useEffect } from 'react';

import { AuthenticationState, AuthErrorType, ENTERPRISE_SSO_REQUIRED_REASON, useUrlQueryParam } from '@neo.tax/shared';

/**
 * Raises the enterprise-SSO refusal the backend reported in the URL, as an ordinary auth error.
 *
 * The reason arrives in the URL because the redirect that carries it is a full page load, which leaves no
 * state behind. It is removed once raised: left there it would raise again on every mount and follow the user
 * onto the next page.
 */
export const useEnterpriseSsoRequiredNotice = (): void => {
  const reason = useUrlQueryParam('reason');

  useEffect(() => {
    if (reason !== ENTERPRISE_SSO_REQUIRED_REASON) {
      return;
    }
    AuthenticationState.updateAuthErrorType(AuthErrorType.ENTERPRISE_SSO_REQUIRED);

    const url = new URL(window.location.href);
    url.searchParams.delete('reason');
    window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  }, [reason]);
};
